import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useEvent } from '@providers/socket';
import { setKillSessionReason } from '@reducks/session';

export const useEventListener = () => {
  const dispatch = useDispatch();

  const onLogoutByAnotherSession = useCallback((data) => {
    const reason = data?.reason;
    dispatch(setKillSessionReason({ reason }));
  }, [
    dispatch,
  ]);

  useEvent('session_information', onLogoutByAnotherSession);
};
